import React from 'react'

import { Info, Activity, Clock } from 'lucide-react'

import useTranslation from '@/core/i18n/useTranslation'
import { cn } from '@/shared/utils/helpers'

interface NavigationItem {
	key: string
	label: string
	icon: React.ElementType
}

interface ZoneNavigationSidebarProps {
	activeTab: string
	onTabChange: (tab: string) => void
}

export const ZoneNavigationSidebar: React.FC<ZoneNavigationSidebarProps> = ({
	activeTab,
	onTabChange,
}) => {
	const { t } = useTranslation('common')

	const navigationItems: NavigationItem[] = [
		{
			key: 'information',
			label: t('entities.zone.tabs.information'),
			icon: Info,
		},
		{
			key: 'connection-status',
			label: t('entities.zone.tabs.connections'),
			icon: Activity,
		},
		{
			key: 'playback-history',
			label: t('entities.zone.tabs.last_events'),
			icon: Clock,
		},
	]

	return (
		<div className="w-[240px] flex-shrink-0 space-y-1">
			{navigationItems.map((item) => {
				const Icon = item.icon
				const isActive = activeTab === item.key

				return (
					<button
						key={item.key}
						onClick={() => onTabChange(item.key)}
						className={cn(
							'w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
							isActive
								? 'bg-sidebar-accent'
								: 'text-muted-foreground hover:text-foreground hover:bg-sidebar-accent/50'
						)}
					>
						<Icon className="h-4 w-4" />
						<span>{item.label}</span>
					</button>
				)
			})}
		</div>
	)
}
